<template>
  <v-menu location="bottom end" :close-on-content-click="true">
    <template #activator="{ props: menuProps }">
      <v-btn v-bind="menuProps" icon variant="text" density="comfortable" class="station-actions-trigger"
        :class="activatorClass" @click.stop>
        <v-icon color="#2F59EB" size="22">mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list class="station-actions-list py-1" density="compact" min-width="176">
      <v-list-item v-hasPermi="['ops:stationList:detail']" class="station-actions-item"
        prepend-icon="mdi-square-edit-outline" rounded="lg" @click="goStationAddStep('basic')">
        <v-list-item-title>基本参数</v-list-item-title>
      </v-list-item>
      <v-list-item v-hasPermi="['ops:stationList:detail']" class="station-actions-item" prepend-icon="mdi-chip"
        rounded="lg" @click="goStationAddStep('device')">
        <v-list-item-title>电站设备</v-list-item-title>
      </v-list-item>
      <v-list-item v-hasPermi="['ops:stationList:detail']" class="station-actions-item station-actions-item--muted"
        prepend-icon="mdi-family-tree" rounded="lg" @click="goStationAddStep('topo')">
        <v-list-item-title class="text-medium-emphasis">电站拓扑</v-list-item-title>
      </v-list-item>
      <v-list-item class="station-actions-item station-actions-item--muted" prepend-icon="mdi-tune-variant" disabled
        rounded="lg">
        <v-list-item-title class="text-medium-emphasis">维护记录</v-list-item-title>
      </v-list-item>
      <v-divider class="my-1" />
      <v-list-item v-hasPermi="['ops:stationList:delete']" class="station-actions-item station-actions-item--muted"
        prepend-icon="mdi-delete-outline" rounded="lg" @click="onDeleteClick">
        <v-list-item-title class="text-medium-emphasis text-error">删除</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  /** 卡片视图里触发按钮可略小 */
  activatorClass: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['delete'])

const router = useRouter()

function onDeleteClick() {
  emit('delete', props.item)
}

const stationId = computed(() => props.item.stationId ?? props.item.id)

/** 进入「新增电站」向导对应步骤（携带 stationId 供后续编辑拉数等扩展） */
function goStationAddStep(stepKey) {
  const id = stationId.value
  if (id == null) return
  router.push({
    path: '/it-operations/station/add',
    query: {
      stationId: String(id),
      step: stepKey,
    },
  })
}
</script>

<style scoped lang="scss">
.station-actions-trigger {
  // margin: 0 -4px;
}

.station-actions-list {
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 10px 28px rgba(8, 40, 87, 0.12);
}

.station-actions-item {
  min-height: 40px !important;
}

.station-actions-item--muted :deep(.v-list-item__prepend > .v-icon) {
  opacity: 0.55;
}

.station-actions-item:not(.station-actions-item--muted) :deep(.v-list-item__prepend > .v-icon) {
  color: #2f59eb;
}
</style>
